<template>
  <div>
    <v-container fluid>
      <v-card class="reportdata-card-main">

        <v-card-title class="d-flex align-center justify-space-between px-0">
          <h3 class="text-h5 font-weight-bold" color="#171717">Question Report Management</h3>
        </v-card-title>

        <v-divider class="model-all-divider"></v-divider>

        <v-card-text style="padding: 0">
          <div class="reportdata-filters-wrapper">
            <!-- Filter Row -->
            <div class="reportdata-filter-card">
              <div class="reportdata-filter-header">
                <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="Date range" width="20" height="20" />
                <span class="reportdata-filter-title">Date Range</span>
              </div>
              <v-row class="items-center justify-between mt-2">
                <!-- Start Date -->
                <v-col cols="12" md="4">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="Start Date" class="text-sm font-medium text-gray-700">
                      Start Date
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                          style="cursor: pointer; margin-left: 4px;" />
                      </template>
                      <span>Select start date for filtering.</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition"
                    location="bottom" min-width="auto">
                    <template #activator="{ props }">
                      <v-text-field
                        v-model="startDate"
                        placeholder="Select date"
                        readonly
                        variant="outlined"
                        v-bind="props"
                        density="compact"
                        class="reportdata-field-date mt-1"
                        clearable
                        @click:clear="clearStartDate"
                        hide-details
                      >
                        <template #prepend-inner>
                          <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      :key="`start-${startPickerYear}-${startPickerMonth}`"
                      :year="startPickerYear"
                      :month="startPickerMonth"
                      @update:year="startPickerYear = $event"
                      @update:month="startPickerMonth = $event"
                      :max="new Date().toISOString().substr(0, 10)"
                      @update:model-value="
                        (val) => {
                          startDate = formatDate(val);
                          startDateFlag = false;
                        }
                      "
                      show-adjacent-months
                      class="date-picker">
                      <template #header>
                        <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                          <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(startPickerYear, startPickerMonth, startDate) }}</div>
                          <v-select
                            v-model="startPickerYear"
                            :items="years"
                            density="compact"
                            variant="plain"
                            hide-details
                            class="month-year-select"
                            style="width: 100px;"
                          ></v-select>
                        </div>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <div class="date-divider">-</div>

                <!-- End Date -->
                <v-col cols="12" md="4">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="End Date" class="text-sm font-medium text-gray-700">
                      End Date
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                          style="cursor: pointer; margin-left: 4px;" />
                      </template>
                      <span>Select end date for filtering.</span>
                    </v-tooltip>
                  </div>
                  <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition"
                    location="bottom" min-width="auto">
                    <template #activator="{ props }">
                      <v-text-field
                        v-model="endDate"
                        placeholder="Select date"
                        readonly
                        variant="outlined"
                        v-bind="props"
                        density="compact"
                        class="reportdata-field-date mt-1"
                        clearable
                        @click:clear="clearEndDate"
                        hide-details
                      >
                        <template #prepend-inner>
                          <img src="@/assets/Icons/new_calendar.png" alt="calendar" style="width: 20px; height: 20px;" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      :key="`end-${endPickerYear}-${endPickerMonth}`"
                      :year="endPickerYear"
                      :month="endPickerMonth"
                      @update:year="endPickerYear = $event"
                      @update:month="endPickerMonth = $event"
                      :min="startDate != null ? startDate : null"
                      @update:model-value="
                        (val) => {
                          endDate = formatDate(val);
                          endDateFlag = false;
                        }
                      "
                      color="#C32E0E"
                      class="date-picker">
                      <template #header>
                        <div class="picker-header-custom d-flex align-center justify-space-between px-4 py-3">
                          <div class="text-h6 font-weight-medium">{{ getFormattedHeaderDate(endPickerYear, endPickerMonth, endDate) }}</div>
                          <v-select
                            v-model="endPickerYear"
                            :items="years"
                            density="compact"
                            variant="plain"
                            hide-details
                            class="month-year-select"
                            style="max-width: 90px;"
                          ></v-select>
                        </div>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Process Prompt-->
                <v-col cols="12" md="3" class="d-flex align-end justify-end ml-auto">
                  <v-divider vertical class="reportdata-filter-divider"></v-divider>
                  <div class="reportdata-action-group">
                    <v-btn
                      id="button-process-reportquestiontop10"
                      variant="elevated"
                      size="large"
                      @click="Search()"
                      :disabled="isProcessDisabled"
                      :class="processButtonClass">
                      <v-img :src="processIcon" alt="Process Icon" class="template-icon" />
                      Process
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Prompt Template Section -->
          <v-card class="reportdata-card-outlined reportdata-question-prompt-card mx-0 my-5">

            <div class="prompt-title-container">
              <v-img :src="promptTemplateIcon" alt="Prompt Template Icon" class="template-icon" />
              Prompt Template
            </div>

            <v-card-text class="pa-5">
              <v-textarea id="prompttemplate-textarea-reportquestiontop10" variant="outlined" counter auto-grow rows="5"
                v-model="promptTemplate" :maxlength="maxLengthChar" rounded="xl"
                :rules="[validatePrompt(promptTemplate)]" required color="#C9C9C9" prepend-inner-icon="mdi-code-tags"
                clearable>
                <template #append-inner>
                  <v-tooltip location="top" max-width="300">
                    <template #activator="{ props }">
                      <v-icon size="small" color="gray-darken-1" v-bind="props">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>
                      Enter your prompt template for question generation
                    </span>
                  </v-tooltip>
                </template>
              </v-textarea>
            </v-card-text>
          </v-card>

          <!-- Data Table with Modern Styling -->
          <v-card class="reportdata-card-table">
            <v-row no-gutters class="pb-4">
              <v-col cols="12" md="6" class="d-flex justify-start align-middle">
                <h2 color="#171717" class="font-weight-bold">{{ "Question Report Data" }}</h2>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-end align-middle">
                <div class="d-flex align-center justify-center">
                  <v-chip size="large" :color="dataUpdate === dataAll && dataAll > 0
                    ? '#2ABF56'
                    : '#EABD07'
                    " variant="elevated" class="px-4 text-white">
                    <v-icon class="mr-2" color="white">
                      {{
                        dataUpdate === dataAll && dataAll > 0
                          ? "mdi-check-circle"
                          : "mdi-clock-outline"
                      }}
                    </v-icon>
                    {{ dataUpdate }} / {{ dataAll }}
                  </v-chip>
                </div>
                <v-tooltip location="top" max-width="200">
                  <template #activator="{ props }">
                    <v-btn v-bind="props" icon class="reportdata-icon-btn reportdata-icon-btn--ghost ml-2"
                      variant="flat" @click="AutoRefresh()" aria-label="Reset filters">
                      <v-icon size="24">mdi-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <div class="reportdata-table-container">
              <v-data-table-server
                v-model:options="options"
                :items="pagedItems"
                :items-length="dataTable.length"
                :headers="headers"
                hide-default-footer
                class="reportdata-table-modern"
                density="comfortable"
                :items-per-page="options.itemsPerPage"
                hover>

                <template v-slot:no-data>
                    <div class="d-flex align-center justify-center">No data available</div>
                  </template>

                <template #item="{ item }">
                  <tr class="reportdata-table-row">
                    <td class="text-center">
                      {{ item.no }}
                    </td>
                    <td>
                      <div class="reportdata-text-container">
                        <span v-for="(subItem, index) in item.title" :key="subItem" class="reportdata-text-standard">
                          {{ subArray(subItem, index, item.title.length) }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      {{ substringLong(item.count) }}
                    </td>
                  </tr>
                </template>
                <template v-slot:bottom>
                  <div class="table-bottom-group">
                    <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                      <div class="d-flex flex-column">
                        <span>Total results {{ dataTable.length }}</span>
                      </div>

                      <v-data-table-footer
                        :items-per-page-options="itemsPerPageOptions"
                        v-model:items-per-page="options.itemsPerPage"
                        v-model:page="options.page"
                        :length="pageCount"
                      />
                    </div>
                  </div>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <v-overlay :value="loading">
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
import processIcon from "@/assets/Icons/report-process.svg";
import promptTemplateIcon from "@/assets/Icons/prompt-template-icon.svg";

export default {
  name: "ReportQuestion",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data() {
    const currentDate = new Date();
    return {
      today: null,
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },

      startDateFlag: false,
      endDateFlag: false,
      startDate: null,
      endDate: null,
      promptTemplate: "",
      maxLengthChar: 4000,
      dataUpdate: 0,
      dataAll: 0,
      dataTable: [],

      itemsPerPageOptions: [
        { title: "10", value: 10 },
        { title: "25", value: 25 },
        { title: "50", value: 50 },
        { title: "100", value: 100 },
        { title: "All", value: -1 },
      ],

      processIcon: processIcon,
      promptTemplateIcon: promptTemplateIcon,

      // Date picker state management
      startPickerYear: currentDate.getFullYear(),
      startPickerMonth: currentDate.getMonth(),
      endPickerYear: currentDate.getFullYear(),
      endPickerMonth: currentDate.getMonth(),
      
      years: Array.from({ length: 10 }, (_, i) => currentDate.getFullYear() - i),
    };
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          title: "Question Category",
          align: "left",
          sortable: false,
          width: "500px",
        },
        {
          title: "Total",
          align: "center",
          sortable: false,
          width: "100px",
        },
      ];
    },
    pagedItems() {
      if (!this.options || !Array.isArray(this.dataTable)) {
        return [];
      }
      const perPage = this.options.itemsPerPage;
      if (!perPage || perPage === -1) {
        return this.dataTable;
      }
      const start = (this.options.page - 1) * perPage;
      return this.dataTable.slice(start, start + perPage);
    },
    pageCount() {
      if (!this.dataTable.length) {
        return 0;
      }
      const perPage = this.options.itemsPerPage;
      if (!perPage || perPage === -1) {
        return 1;
      }
      return Math.ceil(this.dataTable.length / perPage);
    },
    isProcessDisabled() {
      const hasStart = typeof this.startDate === "string" && this.startDate.trim().length > 0;
      const hasEnd = typeof this.endDate === "string" && this.endDate.trim().length > 0;
      const hasPrompt = typeof this.promptTemplate === "string" && this.promptTemplate.trim().length > 0;
      return !(hasStart && hasEnd && hasPrompt);
    },
    processButtonClass() {
      return [
        "reportdata-btn-process",
        { "reportdata-btn-process--active": !this.isProcessDisabled },
      ];
    },
  },
  watch: {
    startDateFlag(newVal) {
      if (newVal) {
        if (this.startDate) {
          const date = new Date(this.startDate);
          this.startPickerYear = date.getFullYear();
          this.startPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.startPickerYear = today.getFullYear();
          this.startPickerMonth = today.getMonth();
        }
      }
    },
    endDateFlag(newVal) {
      if (newVal) {
        if (this.endDate) {
          const date = new Date(this.endDate);
          this.endPickerYear = date.getFullYear();
          this.endPickerMonth = date.getMonth();
        } else {
          const today = new Date();
          this.endPickerYear = today.getFullYear();
          this.endPickerMonth = today.getMonth();
        }
      }
    },
  },
  methods: {
    getFormattedHeaderDate(year, month, selectedDate) {
      let date;
      
      if (selectedDate) {
        const selected = new Date(selectedDate);
        if (selected.getFullYear() === year && selected.getMonth() === month) {
          date = selected;
        } else {
          date = new Date(year, month, new Date().getDate());
        }
      } else {
        const today = new Date();
        if (today.getFullYear() === year && today.getMonth() === month) {
          date = today;
        } else {
          date = new Date(year, month, 1);
        }
      }
      
      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },

    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return (
          inputValue.length <= this.maxLengthChar ||
          "กรุณากรอกข้อมูลตัวอักษรไม่เกิน " +
          this.convertNumberToStringFormat(this.maxLengthChar)
        );
      }
    },

    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },

    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    clearStartDate() {
      this.startDate = null;
    },

    clearEndDate() {
      this.endDate = null;
    },

    Search() {
      let self = this;
      if (self.isProcessDisabled) {
        return;
      }
      self.loading = true;
      self.QuestionGenerate();
    },

    QuestionGenerate() {
      let self = this;
      self.loading = true;

      if (
        self.startDate != null &&
        self.endDate != null &&
        self.promptTemplate != null &&
        self.promptTemplate != ""
      ) {
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
          Prompt: self.promptTemplate,
        };

        self.$call.QuestionGenerate(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataUpdate = dataResponse.data.processingCompleted;
              self.dataAll = dataResponse.data.processAll;
              self.AutoRefresh();
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please fill the required fields!!!",
          showConfirmButton: false,
          timer: 1800,
        });
        self.loading = false;
        return;
      }
    },

    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        self.GetReport();
        if (
          window.location.pathname != "/ReportQuestionTop10" ||
          self.dataUpdate == self.dataAll
        ) {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },

    GetReport() {
      let self = this;
      let temp = {};

      self.$call.GetReportQuestion(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data.requestReport != null) {
              self.startDate =
                dataResponse.data.requestReport.startDate != null
                  ? dataResponse.data.requestReport.startDate.split("T")[0]
                  : self.startDate;
              self.endDate =
                dataResponse.data.requestReport.endDate != null
                  ? dataResponse.data.requestReport.endDate.split("T")[0]
                  : self.endDate;
              self.promptTemplate = dataResponse.data.requestReport.prompt;
            }
            self.dataUpdate = dataResponse.data.processingCompleted;
            self.dataAll = dataResponse.data.processAll;
            self.dataTable = dataResponse.data.listData ?? [];

            const perPage = self.options.itemsPerPage;
            if (!perPage || perPage === -1) {
              self.options.page = 1;
            } else {
              const maxPage = Math.max(1, Math.ceil(self.dataTable.length / perPage));
              if (self.options.page > maxPage) {
                self.options.page = maxPage;
              }
            }
          } else {
            self.dataTable = [];
            self.options.page = 1;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },

    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },

    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 81) {
        return value.substring(0, 80) + ".....";
      }
      return value;
    },

    subArray(value, index, sum) {
      if (index == sum - 1) {
        return value;
      } else {
        return value + ", ";
      }
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    date.setDate(date.getDate() - 30);
    self.startDate = self.convertDateToString2(date);
    self.GetReport();
  },
};
</script>
<style scoped>
.reportdata-field-date :deep(.v-field) {
  border-radius: 16px !important;
}

.reportdata-question-prompt-card {
  background: #ffffff !important;
  box-shadow: unset !important;
}

.reportdata-card-main {
  overflow: hidden;
  background: #ffffff !important;
  box-shadow: unset !important;
}

.model-all-divider {
  width: 100% !important;
  border-color: #CCCCCC !important;
  height: 2px !important;
  opacity: 1 !important;
  margin: 5px 0px 25px 0px !important;
}

.reportdata-filters-wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.reportdata-filter-card {
  background: transparent;
  border: 1px solid #C9C9C9;
  border-radius: 18px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.reportdata-field-date :deep(.v-field) {
  border-radius: 16px !important;
}

.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
  background: #ffffff;
}

.date-style :deep(.v-field__outline),
.date-style :deep(.v-field__overlay) {
  display: none;
}

.date-style :deep(.v-field) {
  min-height: 40px;
}

.date-style :deep(.v-field__input) {
  padding: 8px 0 8px 4px;
  color: #1f1f1f;
  font-weight: 600;
  font-size: 14px;
  min-height: 40px;
}

.date-style :deep(.v-field__prepend-inner) {
  padding-top: 8px;
  padding-left: 4px;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 232px;
  max-width: 100%;
  min-width: 200px;
}

.date-label-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.date-label {
  color: #4b4b4b;
  font-weight: 600;
  font-size: 14px;
}

.date-tooltip-icon {
  cursor: pointer;
}

.reportdata-filter-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
}

.date-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #646464;
  font-weight: 700;
  font-size: 30px;
  padding-top: 20px;
  margin: 10px;
}

.reportdata-filter-divider {
  height: 50px;
  align-self: flex-end;
  margin: 0 25px 0px 15px;
  border-color: #C9C9C9 !important;
  opacity: 1;
}

.reportdata-btn-process {
  color: #ffffff;
  border-radius: 16px;
  background: #C1C3CB;
  transition: background 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.reportdata-btn-process:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

.reportdata-btn-process--active {
  background: linear-gradient(90deg, #C32E0E 0%, #F67760 100%) !important;
  color: #ffffff !important;
}

.template-icon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  max-width: 25px;
  max-height: 25px;
  flex-shrink: 0;
  object-fit: contain;
}

.reportdata-card-table {
  border: 1px solid #c9c9c9 !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: none !important;
  margin: 5px 0px;
  padding: 20px;
}

.prompt-title-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 15px 20px 0 20px;
}

.reportdata-icon-btn {
  border-radius: 50%;
  height: 42px;
  width: 42px;
  min-width: 42px;
  transform: scaleX(-1);
}

.reportdata-icon-btn--ghost {
  background: #ffffff !important;
  color: #171717 !important;
  border: 1px solid #d0d0d0 !important;
}

:deep(thead) {
  background-color: #FFF2F2 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
